module.exports = "/_next/static/images/adc5821d8cafb497978a976d8aeac4de-hands-holding-cards-xs@1x.jpg.webp";